import { createMailReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsMail';
import { createTeamReference } from '../../firebase/firebaseAPICalls/FirebaseAPICallsTeam';
import { getCurrentDateTime } from '../DateTime';
import { SportsType } from '../enums/SportsType';
import { MailerSendMailObject } from '../interface/mailInterface/MailerSendMailInterface';
import { SubscriptionDomainEmailObject } from '../interface/SubscriptionInfoInterface';

export const createSubscriptionMailObject = (
    mailId: string,
    teamId: string,
    teamName: string,
    organizationId: string,
    organizationName: string,
    sportsType: SportsType,
    subscriptionType: 'Website' | 'Domain' | 'Email',
    metadata: SubscriptionDomainEmailObject[],
    email: string,
    url: string,
): MailerSendMailObject => {
    return {
        id: mailId,
        reference: createMailReference(mailId),
        teamId,
        teamReference: createTeamReference(teamId),
        from: { email: 'admin@optimxsports.com', name: 'OptimX Sports' },
        to: [{ email: 'contact@optimxtechnologies.com', name: 'OptimX Sports' }],
        cc: [],
        bcc: [],
        reply_to: {},
        subject: createSubscriptionMailSubject(teamName, subscriptionType),
        html: createSubscriptionMailText(teamId, teamName, organizationId, organizationName, subscriptionType, metadata, email, url),
        text: createSubscriptionMailText(teamId, teamName, organizationId, organizationName, subscriptionType, metadata, email, url),
        template_id: '',
        variables: [],
        personalization: [],
        tags: ['subscription', `subscription_${teamId}`, `subscription_${subscriptionType.toLowerCase()}`, `subscription_${subscriptionType.toLowerCase()}_${teamId}`, teamId],
        sportsType,
        timeModified: getCurrentDateTime(),
        timeCreated: getCurrentDateTime(),
    };
};

const createSubscriptionMailText = (
    teamId: string,
    teamName: string,
    organizationId: string,
    organizationName: string,
    subscriptionType: 'Website' | 'Domain' | 'Email',
    metadata: SubscriptionDomainEmailObject[],
    email: string,
    url: string,
) => {
    if (metadata.length === 0) {
        return `${subscriptionType} subscription has been activated --- Team Name is: ${teamName}. Team Id is: ${teamId}. Organization Name is: ${organizationName}. Organization Id is: ${organizationId}. Email is: ${email}. URL is: ${url}`;
    }
    if (subscriptionType === 'Email') {
        let str = '(';
        metadata.forEach((emailLocal: SubscriptionDomainEmailObject) => {
            str += `${emailLocal.emailId} - ${emailLocal.backupEmailId}, `;
        });
        str += ')';
        return `${subscriptionType} subscription has been activated --- Team Name is: ${teamName}. Team Id is: ${teamId}. Organization Name is: ${organizationName}. Organization Id is: ${organizationId}. Email is: ${email}. URL is: ${url}. Metadata is ${str}`;
    }
    return `${subscriptionType} subscription has been activated --- Team Name is: ${teamName}. Team Id is: ${teamId}. Organization Name is: ${organizationName}. Organization Id is: ${organizationId}. Email is: ${email}. URL is: ${url}. Metadata is ${metadata}`;
};

const createSubscriptionMailSubject = (teamName: string, subscriptionType: 'Website' | 'Domain' | 'Email') => {
    return `${subscriptionType} SUBSCRIPTION FROM ${teamName}`;
};
